import React from 'react';
import { Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const CalendarComponent = ({ localizer, events, formats, minTime, maxTime, eventStyleGetter, onSelectEvent }) => {
  return (
    <Calendar
      localizer={localizer}
      events={events}
      startAccessor="start"
      endAccessor="end"
      formats={formats}
      min={minTime}
      max={maxTime}
      getNow={() => new Date()}
      defaultView="day"
      views={['day']}
      eventPropGetter={eventStyleGetter}
      onSelectEvent={onSelectEvent}
      dayLayoutAlgorithm="no-overlap"
    />
  );
};

export default CalendarComponent;
